export const TITLE_PREFIX = "[CYPRESS]";

export function getDataTestProp(id: string, value?: string | number | boolean) {
  return { [id]: value == undefined ? "" : value };
}

export function getSelector({
  id,
  comparator = "=",
  value,
}: {
  id: string;
  comparator?: "=" | "^=" | "$=" | "*=" | "~=" | "|=" | "!=";
  value?: string | number | boolean;
}) {
  return `[${id}${value == undefined ? "" : `${comparator}"${value}"`}]`;
}

export async function getFileFromUrl(
  url: string,
  filename?: string,
): Promise<File> {
  const { default: axios } = await import("axios");
  const DEFAULT_FILENAME = "file";

  const response = await axios.get(url, { responseType: "blob" });

  const data = response.data;

  const file = new File([data], filename || DEFAULT_FILENAME, {
    type: data.type,
    lastModified: new Date().getTime(),
  });

  return file;
}
